import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { TableHeaderCell } from 'utils/types';
import { omit } from 'lodash';
import css from './SortableHeaderCell.scss';

export default class SortableHeaderCell extends React.Component {

  /**
   * When the user presses the enter or space key, trigger the given onSortChange function
   * @param {SyntheticEvent} event - the fired onKeyDown event
   */
  handleKeyDown = (event) => {
    // keyCode 13 = enter
    // keyCode 32 = space
    if (event.keyCode !== 13 && event.keyCode !== 32) return;
    this.handleClick(event);
  }

  /**
   * When the user clicks on the header cell, trigger the given onSortChange function
   * @param {SyntheticEvent} event - the fired onChange event
   */
  handleClick = (event) => {
    event.preventDefault();
    this.props.onSortChange(this.props.header.sortValue);
  }

  render() {
    return <Table.HeaderCell aria-sort={!this.props.isSorted ? "none" : this.props.sortDirection}
                             className={css["header-cell"]}
                             id={this.props.header.sortValue}
                             onClick={this.handleClick}
                             role="columnheader"
                             scope="col"
                             sorted={ !this.props.isSorted ? null : this.props.sortDirection}
                             {...omit(this.props.header, ['sortValue', 'content'])}>
      <span onKeyDown={this.handleKeyDown}
            role="button"
            tabIndex="0">
        {this.props.header.content}
      </span>
    </Table.HeaderCell>
  }

}

SortableHeaderCell.propTypes = {
  header: TableHeaderCell.isRequired,
  isSorted: PropTypes.bool.isRequired,
  onSortChange: PropTypes.func.isRequired,
  sortDirection: PropTypes.string.isRequired
};
